<template>
  <div class="contentUs">
    <div class="cuBox">
      <ul>
        <li>
          <img src="../../static/common/email.png" alt="">
          <p>
            <span>客服邮箱</span>
            <span @click="handleEmail" style="cursor: pointer;">cs@rlc9000.com</span>
          </p>
        </li>
        <li>
          <img src="../../static/common/localhost.png" alt="">
          <p>
            <span style="font-weight:500">注册地址: Flat 1511, 15/F, Beverley Commercial Centre, 87 Chatham Road South, Tsimshatsui, Kowloon, Hong Kong</span>
            <span>营运地址: Flat 11 15/F Beverley Commercial Centre, 87-105 Chatham Road South, Tsimshatsui, Kowloon, Hong Kong</span>
          </p>
        </li>
        <li>
          <img src="../../static/common/phone.png" alt="">
          <p>
            <span>联系电话</span>
            <span>+852 23927848</span>
          </p>
        </li>
      </ul>
      <div class="levelLine"></div>
      <div class="tips">
        <ul>
          <li>
            风险提示：红狮金业有限公司(以下称：红狮金业)提醒您，保证金交易及买卖存在高风险，客户需提前了解所面临的风险，不应该贸然进行投资交易。客户亦应该谨慎考虑自身的投资目标、经验、财务状况及风险承受能力，自行衡量是否适合进行投资。任何保证金交易都具备一定风险，包括（但不限于）杠杆、信用可靠度、有限的法务保护，及可能很大程度影响到货币或货币对价格或交易量的市场动荡因素。
          </li>
          <!-- <li>应用名称：红狮智富</li> -->
        </ul>
        <ul>
          <!-- <li>APP开发者：红狮金业有限公司</li>
          <li>应用版本：2.9.1</li> -->
          <li @click="checkPower(1)" style="cursor: pointer;">应用权限：查看权限</li>
          <li>更新时间：2022年2月17日</li>
          <li @click="checkPower(2)" style="cursor: pointer;">隐私权限：查看权限</li>
          <li>红狮金业有限公司是香港黄金交易所AA类行员，行员编号：081</li>
          <li>唯一业务识别码 : 52152035</li>
        </ul>
        <ul>
          <li>受限地區：</li>
          <li>红狮金业有限公司不為某些司法管轄區的公民/居民提供服務，例如 加拿大、古巴、伊朗、伊拉克、日本、緬甸、朝鮮、蘇丹、敘利亞、土耳其、美國。 </li>
        </ul>
      </div>
      <div class="qrcode">
        <img src="../../static/common/qrcode.png" alt="">
        <div class="qrcode-cont">
          <p>红狮金业有限公司</p>
          <p>RED LION BULLION LIMITED</p>
          <p>贵金属及宝石交易商注册号码：A-B-23-08-01030</p>
        </div>
      </div>
      <div class="copyRight">COPYRIGHT(©) 2023 红狮金业</div>
    </div>
  </div>
</template>

<script>
import router from '../router';

export default {
  name:'Contactus',
  data(){
    return{
      
    }
  },
  methods:{
    checkPower(attr){
      if(attr == 1){
        this.$router.push({
          name:'Application'
        })
        // window.open('https://sem.rlclead.com/agreement/permission');
      }else{
        // window.open('https://sem.rlclead.com/agreement/privacy');
        this.$router.push({
          name:'Privacy'
        })
      }
    },
    handleEmail() {
      window.open('mailto:cs@rlc9000.com')
    },
  }
}
</script>

<style lang="less" scoped>
  .contentUs{
    width: 100%;
    background-color: #121212;
    color: #616161;
    .cuBox{
      width: 1527px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding-top: 30px;
      ul{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0px;
        height: 170px;
        li{
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: justify;
          p{
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            color: #ffffff;
            span{
              line-height: 30px;
            }
            span:nth-child(1){
              font-weight: 600;
              font-size: 14px;
            }
            span:nth-child(2){
              font-size: 13px;
            }
          }
        }
      }
      ul:nth-child(2){
        margin-left: 110px;
      }
      .levelLine{
        width: 100%;
        height: 1px;
        background-color: #393a3c;
        margin: 15px auto 20px;
      }
      .tips{
        width: 100%;
        box-sizing: border-box;
        padding: 0 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        ul{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 0;
          li{
            line-height: 35px;
            font-size: 14px;
          }
        }
      }
      .qrcode {
        width: 35%;
        height: auto;
        display: flex;
        position: relative;
        top: -20px;
        left: 36.5%;
        img {
          width: 125px;
          height:125px;
        }
        .qrcode-cont {
          padding-left: 25px;
          font-size: 14px;
        }
      }
      .copyRight{
        text-align: center;
        font-size: 13px;
        margin: 15px 0 30px 0;
      }
    }
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .contentUs{
      .cuBox{
        width: 100%;
        box-sizing: border-box;
        padding: 20px 12px 0;
        align-items: flex-start;
        ul{
          height: auto;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          li{
            width: 100%;
            align-items: flex-start;
            margin-bottom: 15px;
            img{
              width: 18px;
              height: auto;
              margin-top: 6px;
            }
            p{
              flex: 1;
              margin-left: 12px;
              span{
                line-height: 22px;
              }
              span:nth-child(1){
                font-size: 13px;
              }
              span:nth-child(2){
                font-size: 12px;
              }
            }
          }
        }
        ul:nth-child(2){
          margin-left: 0;
        }
        .levelLine{
          margin: 5px auto 15px;
        }
        .tips{
          flex-direction: column;
          align-items: flex-start;
          ul{
            margin-bottom: 10px;
            li{
              line-height: 22px;
              font-size: 12px;
              margin-bottom: 0;
              text-align: justify;
            }
          }
        }
        .qrcode{
          width: 100%;
          position: static;
          align-items: center;
          margin-top: 10px;
          img{
            width: 90px;
            height: 90px;
          }
          .qrcode-cont{
            flex: 1;
            padding-left: 12px;
            font-size: 12px;
            line-height: 20px;
          }
        }
        .copyRight{
          width: 100%;
          font-size: 12px;
          margin: 15px 0 20px 0;
        }
      }
    }
  }
</style>